import { mixinDialogActions, mixinDialogGetters, mixinDialogMutations } from '@/mixins/vuexDialogs'
import { getField, updateField } from 'vuex-map-fields'
import selectedPlan from '../constants/selectedPlan'
import { setProviderByPaymentMethod } from '@/utils/payments'
import {
  companyInfoDefault,
  FREE_TARIFF_NAME,
  PAYMENT_METHOD_CLOUDPAY_NAME,
  PAYMENT_METHOD_CRYPTOMUS_OR_INXY,
  PAYMENT_METHOD_CRYPTOMUS_NAME,
  PAYMENT_METHOD_INXY_NAME,
  paymentInfoDefault,
  paymentSummaryDefault, paymentMethods
} from '@/constants/plans'

export default {
  namespaced: true,
  state: {
    selectedPlan,
    dialogs: {
      prolongPlan: false,
      switchPlan: false,
      paymentFromTrial: false,
      updatePlan: false,
      changeTariff: false,
      changeTariffRestriction: false,
      confirmCustomPlanChange: false
    },
    promocode: {
      isSet: false,
      discount: 0,
      alert: false,
      alertMessage: ''
    },
    promocodeState: {
      status: '',
      discount: 0,
      errorText: ''
    },
    loadingBalance: false,
    currentCase: null,
    balance: {},
    promoAlertError: false,
    needPay : false,
    invoice: {
      id: null,
      merchant_id: null,
      sum: 0,
      teamId: null,
      description: '',
      coin: null,
      days: null,
      provider: null,
      currency: 'RUR',
      opt_client_id: null,
      signature: null
    },
    countryCode: '',
    isLocalCard: false,
    estimate: 0,
    paymentInfo: Object.assign({}, paymentInfoDefault),
    companyInfo: Object.assign({}, companyInfoDefault),
    paymentSummary: Object.assign({}, paymentSummaryDefault),
    paymentSummaryUpdating: false,
    paymentMethods: [...paymentMethods],
    dontShowPaymentLeftSideScroll: false
  },

  getters: {
    ...mixinDialogGetters,
    getField,

    selectedPlan: state => state.selectedPlan,
    promocode: state => state.promocode,
    balance: state => state.balance,
    needPay: state => state.needPay,
    loadingBalance: state => state.loadingBalance,
    currentCase: state => state.currentCase,
    countryCode: state => state.paymentInfo.countryCode ?? state.countryCode,
    paymentInfo: state => state.paymentInfo,
    isLocalCard: state => state.isLocalCard,
    promocodeState: state => state.promocodeState,
    companyInfo: state => state.companyInfo,
    paymentSummary: state => state.paymentSummary,
    paymentSummaryUpdating: state => state.paymentSummaryUpdating,
    paymentMethods: state => state.paymentMethods,
    dontShowPaymentLeftSideScroll: state =>state.dontShowPaymentLeftSideScroll,
  },

  mutations: {
    ...mixinDialogMutations,
    updateField,

    SET_LOADING: (state, payload) => {
      state.loadingBalance = payload
    },

    SET_CASE: (state, payload) => {
      state.currentCase = payload
    },

    SET_DISCOUNT: (state, discount) => {
      state.selectedPlan.discount = discount
    },

    SET_PAYMENT_METHOD: (state, payload) => {
      state.paymentInfo.paymentMethod = null
      state.paymentInfo.paymentMethod = payload
    },

    SET_PROMOCODE: (state, payload) => {
      state.promocode = {
        isSet: payload.isSet,
        discount: payload.discount,
        alert: payload.alert,
        alertMessage: payload.alertMessage,
        err: payload.err || false,
      }
    },

    SET_PROMOCODE_STATE: (state, payload) => {
      state.promocodeState = payload
    },

    SET_COIN: (state, payload) => {
      state.invoice.coin = payload
    },

    SET_WALLET: (state, payload) => {
      if (payload === 'Capitalist') {
        state.invoice.provider = 'capitalist'
        state.invoice.coin = null
      } else {
        state.invoice.provider = 'unlimint'
        state.invoice.coin = payload
      }
    },

    SET_COUNTRY: (state, payload) => {
      state.paymentInfo.countryCode = payload
      state.countryCode = payload
    },

    CLEAR_INVOICE: (state) => {
      state.invoice.signature = ''
      state.invoice.sum = 0
      state.invoice.provider = null
      state.invoice.days = 0
      state.invoice.id = null
      state.invoice.currency = ''
      state.invoice.description = ''
    },

    SET_BALANCE: (state, payload) => state.balance = payload,

    SET_PAYMENT_SUMMARY: (state, payload) => state.paymentSummary = Object.assign({}, payload),

    RELOAD_PAYMENT_INFO: state => {
      state.paymentInfo = Object.assign({}, paymentInfoDefault)
      state.paymentSummary = Object.assign({}, paymentSummaryDefault)
      state.companyInfo = Object.assign({}, companyInfoDefault)
      state.balance = {}
    },

    SET_PAYMENT_INFO_PROMOCODE: (state, payload) => {
      state.paymentInfo.promocode = payload
    },

    UPDATE_PAYMENT_INFO: (state, payload) => {
      state.paymentInfo = Object.assign({}, state.paymentInfo, payload)
    },

    SET_IS_LOCAL_CARD: (state, payload) => {
      state.isLocalCard = payload
    },

    SET_COMPANY_INFO: (state, payload) => {
      state.componentInfo = payload
    },

    UPDATE_COMPANY_INFO: (state, payload) => {
      state.componentInfo = Object.assign(state.componentInfo, payload)
    },

    UPDATE_PAYMENT_SUMMARY: (state, payload) => {
      state.paymentSummary = Object.assign(state.paymentSummary, payload)
    },

    RESET_COMPANY_INFO: (state) => {
      state.companyInfo = companyInfoDefault
    },

    SET_PAYMENT_SUMMARY_UPDATING: (state, payload) => {
      state.paymentSummaryUpdating = payload
    },

    SET_PAYMENTS_METHODS: (state, payload) => {
      state.paymentMethods = payload
    },

    SET_PAYMENTS_SIDE_SCROLL: (state, payload) => {
      state.dontShowPaymentLeftSideScroll = payload
    }
  },

  actions: {
    ...mixinDialogActions,

    async createPaymentInvoice({ state, rootGetters }) {
      let data = {
        plan: state.paymentInfo.plan.toLowerCase(),
        usersLimit: parseInt(state.paymentInfo.additionalUsers, 10) + 1,
        browserProfilesLimit: parseInt(state.paymentInfo.profilesCount, 10),
        days: parseInt(state.paymentInfo.prolongMonths) * 30,
        provider: PAYMENT_METHOD_CLOUDPAY_NAME || PAYMENT_METHOD_CRYPTOMUS_OR_INXY,
        promo: state.paymentInfo.promocode ? state.paymentInfo.promocode : null,
        planBasePrice: state.paymentSummary.planBasePrice
            + state.paymentSummary.additionalUsersPrice + state.paymentSummary.additionalProfilesPrice,
        remainingFare: state.balance.balance,
        companyInfo: state.companyInfo,
        isCustomTariff: state.paymentInfo.isCustomTariff || false
      }

      data = setProviderByPaymentMethod(state, data)

      if (data.companyInfo.countryCode) {
        data.companyInfo.countryCode = data.companyInfo.countryCode.toUpperCase()
      }

      if (data.plan === FREE_TARIFF_NAME) {
        data.browserProfilesLimit += parseInt(state.paymentInfo.additionalProfiles, 10)
        data.usersLimit = 1
      }

      const response = await this._vm.api.post(`/subscription/invoices`, data)


      if (response.data.success) {
        state.invoice.signature = response.data.data.signature
        state.invoice.email = rootGetters['main/profile'].username
        state.invoice.sum = response.data.data.sum
        state.invoice.provider = response.data.data.provider
        if (state.invoice.provider === PAYMENT_METHOD_INXY_NAME || state.invoice.provider === PAYMENT_METHOD_CRYPTOMUS_NAME) {
          state.invoice.provider = PAYMENT_METHOD_CRYPTOMUS_OR_INXY
        }
        state.invoice.days = response.data.data.days
        state.invoice.id = response.data.data.invoiceId
        state.invoice.currency = response.data.data.currency === "RUB" ? "RUR" : response.data.data.currency
        state.invoice.teamId = rootGetters['main/profile'].teamId
        state.invoice.description = 'Dolphin Anty invoice #' + response.data.data.invoiceId
      }

      return response
    },

    async createUpdateInvoice({ state, rootGetters, dispatch }) {
      let profilesCount = state.paymentInfo.profilesCount

      if (typeof profilesCount == 'object') {
        profilesCount = profilesCount.value
      }

      let data = {
        plan: state.paymentInfo.plan.toLowerCase(),
        usersLimit: parseInt(state.paymentInfo.additionalUsers, 10) + 1,
        browserProfilesLimit: profilesCount,
        days: parseInt(state.paymentInfo.prolongMonths) * 30,
        provider: 'upgrade',
        promo: state.paymentInfo.promocode ? state.paymentInfo.promocode : null,
        teamId: rootGetters['main/profile'].teamId,
        planBasePrice: state.paymentSummary.planBasePrice
            + state.paymentSummary.additionalUsersPrice + state.paymentSummary.additionalProfilesPrice,
        remainingFare: state.balance.balance,
        companyInfo: state.companyInfo,
        isCustomTariff: state.paymentInfo.isCustomTariff || false
      }

      data = setProviderByPaymentMethod(state, data)

      if (data.plan === FREE_TARIFF_NAME) {
        data.browserProfilesLimit = state.paymentInfo.additionalProfiles
        data.browserProfilesLimit += 10
        data.usersLimit = 1
      }

      if (data.companyInfo.countryCode) {
        data.companyInfo.countryCode = data.companyInfo.countryCode.toUpperCase()
      }

      try {
        if (data.days === 0) {
          delete data['days']
        }

        const response = await this._vm.api.post(`/subscription/invoices/upgrade`, data)

        if (response.data.success) {
          state.invoice.signature = response.data.data.signature
          state.invoice.email = rootGetters['main/profile'].username
          state.invoice.sum = response.data.data.sum
          state.invoice.provider = response.data.data.provider
          if (state.invoice.provider === PAYMENT_METHOD_INXY_NAME || state.invoice.provider === PAYMENT_METHOD_CRYPTOMUS_NAME) {
            state.invoice.provider = PAYMENT_METHOD_CRYPTOMUS_OR_INXY
          }
          state.invoice.days = response.data.data.days
          state.invoice.id = response.data.data.invoiceId
          state.invoice.currency = response.data.data.currency === "RUB" ? "RUR" : response.data.data.currency
          state.invoice.teamId = rootGetters['main/profile'].teamId
          state.invoice.description = 'Dolphin Anty invoice #' + response.data.data.invoiceId
        }

        return response
      } catch (error) {
        dispatch('main/alert', {
          color: 'red',
          message: error.response.data.error.text ? error.response.data.error.text : error.response.data.error
        }, {
          root: true
        })
      }

    },

    async createPaymentRenewInvoice({state, rootGetters}) {
      let data = {
        plan: state.paymentInfo.plan.toLowerCase(),
        usersLimit: parseInt(rootGetters['main/profile'].subscription.users.limit),
        browserProfilesLimit: parseInt( rootGetters['main/profile'].subscription.browserProfiles.limit, 10),
        days: parseInt(state.paymentInfo.prolongMonths) * 30,
        provider: PAYMENT_METHOD_CLOUDPAY_NAME || PAYMENT_METHOD_CRYPTOMUS_OR_INXY,
        promo: state.paymentInfo.promocode ? state.paymentInfo.promocode : null,
        planBasePrice: state.paymentSummary.planBasePrice
            + state.paymentSummary.additionalUsersPrice + state.paymentSummary.additionalProfilesPrice,
        remainingFare: state.balance.balance,
        companyInfo: state.companyInfo,
        isCustomTariff: state.paymentInfo.isCustomTariff || false
      }

      data = setProviderByPaymentMethod(state, data)

      if (data.companyInfo.countryCode) {
        data.companyInfo.countryCode = data.companyInfo.countryCode.toUpperCase()
      }

      const response = await this._vm.api.post(`/subscription/invoices`, data)

      if (response.data.success) {
        state.invoice.signature = response.data.data.signature
        state.invoice.email = rootGetters['main/profile'].username
        state.invoice.sum = response.data.data.sum
        state.invoice.provider = response.data.data.provider
        if (state.invoice.provider === PAYMENT_METHOD_INXY_NAME || state.invoice.provider === PAYMENT_METHOD_CRYPTOMUS_NAME) {
          state.invoice.provider = PAYMENT_METHOD_CRYPTOMUS_OR_INXY
        }
        state.invoice.days = response.data.data.days
        state.invoice.id = response.data.data.invoiceId
        state.invoice.currency = response.data.data.currency === "RUB" ? "RUR" : response.data.data.currency
        state.invoice.teamId = rootGetters['main/profile'].teamId
        state.invoice.description = 'Dolphin Anty invoice #' + response.data.data.invoiceId
      }

      return response
    },

    setInvoice(payload) {
      this.state.invoice.sum = payload.sum
      this.state.invoice.provider = payload.provider
      this.state.invoice.days = payload.days
      this.state.invoice.id = payload.invoiceId
      this.state.invoice.currency = payload.currency === "RUB" ? "RUR": payload.currency
    },

    async checkPromocode ({ commit }, payload) {
      return this._vm.api.post(`/subscription/check-promo`, {
        promo: payload
      })
    },

    async setPromocodeState ({ commit }, payload) {
      commit('SET_PROMOCODE_STATE', payload)
    },

    async sendPromocode({ commit, rootGetters }, value) {
      try {
        const response = await this._vm.api.post(`/subscription/check-promo`, {
          promo: value
        })

        if (response.status === 200 && response.data && response.data.data && response.data.data.exists) {
          commit("SET_DISCOUNT", response.data.data.discount)
          commit("SET_PROMOCODE", {
            isSet: true,
            discount: parseInt(response.data.data.discount, 10),
            alert: response.data.data.discount === 0,
            alertMessage: response.data.data.discount === 0 && rootGetters['main/profile'].team.usedPromo ?
                "promoForFirstPayment" : "promoLimitExceed"
          })
        } else {
          // commit("SET_DISCOUNT", '0')
          commit("SET_PROMOCODE", { isSet: true, discount: 0, err: true })
        }
      } catch (error) {
        console.log(error)
        // commit("SET_DISCOUNT", '0')
        commit("SET_PROMOCODE", { isSet: true, discount: 0, err: true })
      }
    },

    async paymentMethod({ commit }, payload) {
      commit("SET_PAYMENT_METHOD", payload)
    },

    async setPromocode({ commit }, payload) {
      commit("SET_PROMOCODE_STATE", payload)
    },

    setPaymentInfoPromocode({ commit }, payload) {
      commit("SET_PAYMENT_INFO_PROMOCODE", payload)
    },

    loadingBalance({ commit }, payload) {
      commit("SET_LOADING", payload)
    },

    setCase({ commit }, payload) {
      commit("SET_CASE", payload)
    },

    async setCoin({ commit }, payload) {
      commit("SET_COIN", payload)
    },

    async setWallet({ commit }, payload) {
      commit("SET_WALLET", payload)
    },

    async setBalance ({ commit }, payload) {
      commit('SET_BALANCE', payload)
    },

    clearInvoice({ commit }) {
      commit("CLEAR_INVOICE")
    },

    clearPromo({ commit }) {
      commit("SET_PROMOCODE_STATE", {
        status: '',
        discount: 0,
        errorText: ''
      })
    },

    async setCountryCode({ commit },  payload) {
      commit("SET_COUNTRY",  payload)
    },

    async setIsLocalCard ({ commit }, payload) {
      commit('SET_IS_LOCAL_CARD', payload)
    },

    async updatePaymentInfo ({ commit }, payload) {
      commit('UPDATE_PAYMENT_INFO', payload)
    },

    async setPaymentSummaryUpdating ({ commit }, payload) {
      commit('SET_PAYMENT_SUMMARY_UPDATING', payload)
    },

    async reloadPaymentInfo ({ commit }) {
      commit('RELOAD_PAYMENT_INFO')
    },

    async setPaymentMethods ({ commit }, payload) {
      commit('SET_PAYMENTS_METHODS', payload)
    },

    async setPaymentSummary ({ commit }, payload) {
      commit('SET_PAYMENT_SUMMARY', payload)
    },

    async setPaymentSideScroll ({ commit }, payload) {
      commit('SET_PAYMENTS_SIDE_SCROLL', payload)
    },

    async sign ({ commit }) {
      const data = {
        number: this.invoice.id,
        description: 'Dolphin Anty',
        amount: this.invoice.sum,
        currency: this.invoice.currency,
        opt_client_id: this.invoice.teamId
      }

      const response = await this._vm.api.post('/subscription/sign-form', data)

      if (response.status === 200 &&
          response.data &&
          response.data.success
      ) {
        commit('SIGN_FORM', data)
      }
    },

    async setCompanyInfo ({ commit }, payload) {
      commit('SET_COMPANY_INFO', payload)
    },

    async updateCompanyInfo ({ commit }, payload) {
      commit('UPDATE_COMPANY_INFO', payload)
    },

    async updatePaymentSummary ({ commit }, payload) {
      commit('UPDATE_PAYMENT_SUMMARY', payload)
    }
  }
}
